<style lang="scss">
.sound-test {
  .bar {
    --volume: 0%;
    position: relative;
    width: 100%;
    height: 50px;
    border-radius: 5px;
    margin-bottom: 20px;
    border: solid 1px lightgrey;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      border-radius: 5px;
      width: var(--volume);
      background-color: lightgreen;
      transition: width 100ms linear;
    }
  }
}
</style>

<!-- eslint-disable -->
<template>
  <section class="sound-test">
    <h5>Headphone check</h5>
    <section>
      <b-btn class="full-width" :variant="playing ? 'danger' : 'primary'" @click="playSample(!playing)">
        {{ playing ? 'Stop' : 'Play' }}
        Sound
      </b-btn>
      <audio id="sample-audio" loop>
        <source :src="sample" type="audio/mpeg">
        Your browser does not support the audio tag.
      </audio>
    </section>

    <section class="mt-1">
      <h5>Microphone test</h5>
      <b-btn class="full-width" v-if="!microphoneAllowed" variant="primary" @click="getMicrophone">Check Microphone Is
        Available
      </b-btn>
      <section class="full-width" v-if="microphoneAllowed">
        <p class="mt-1"><i class="fas fa-check-circle text-success"></i> Microphone found, you can now test your sound
          below</p>
        <b-btn :variant="microphoneTest ? 'danger' : 'primary'" class="full-width"
               @click="startMicrophoneTest(!microphoneTest)">{{ microphoneTest ? 'Stop' : 'Start' }} Testing Sound
        </b-btn>
        <p class="mt-1 mb-0" v-if="microphoneTest">Please say some words...</p>
        <div v-show="microphoneTest" class="bar mt-1" id="volume-visualizer"></div>
      </section>
    </section>

  </section>
</template>
<!-- eslint-enable -->

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      playing: false,
      microphoneTest: false,
      sample: require('../../assets/sound/sample.mp3'),
      microphoneAllowed: false,
      stream: null,
      audioSource: null,
      audioContext: null,
      delay: null,
      volumeCallback: null,
      volumeInterval: null,
      volumeVisualizer: null,
    };
  },
  mounted() {
  },
  beforeDestroy() {
    if (this.microphoneAllowed) {
      this.startMicrophoneTest(false);

      if (this.stream) {
        const tracks = this.stream.getTracks(); // get all tracks
        tracks.forEach(track => { // stop all tracks
          track.stop();
        });
      }
    }
  },
  methods: {
    playSample(value) {
      this.playing = value;
      const audioElm = document.getElementById('sample-audio');
      if (audioElm) {
        if (this.playing) {
          audioElm.play();
        } else {
          audioElm.pause();
          audioElm.currentTime = 0;
        }
      }
    },
    startMicrophoneTest(value) {
      if (this.audioContext) {
        this.microphoneTest = value;

        if (value) {
          this.playMicrophone();
          if (this.volumeCallback !== null && this.volumeInterval === null) this.volumeInterval = setInterval(this.volumeCallback, 100);
        } else if (this.volumeInterval !== null) {
          clearInterval(this.volumeInterval);
          this.volumeInterval = null;
          this.volumeVisualizer.style.setProperty('--volume', `${0}%`);
          this.delay.disconnect(this.audioContext.destination); // delay object controls output to speaker
        }
      } else {
        this.throwCameraError();
      }
    },
    playMicrophone() {
      this.delay = this.audioContext.createDelay(); // create a delay object (so sound is not instant)
      this.delay.delayTime.value = 1; // 1 second
      this.audioSource.connect(this.delay); // connect the audio source with the delay object
      this.delay.connect(this.audioContext.destination); // connect the delay with the speaker (play sound)
      this.setUpVisualizer(this.audioContext, this.delay); // play the visualizer with the delay node as audio src
    },
    async getMicrophone() {
      navigator.mediaDevices.getUserMedia({video: false, audio: true}).then(stream => {
        this.stream = stream;
        this.microphoneAllowed = true;
        this.audioContext = new AudioContext();
        this.audioSource = this.audioContext.createMediaStreamSource(stream);
      }).catch(() => {
        this.throwCameraError();
      });
    },
    setUpVisualizer(audioContext, audioSource) {
      this.volumeVisualizer = document.getElementById('volume-visualizer');
      const analyser = audioContext.createAnalyser();
      analyser.fftSize = 512;
      analyser.minDecibels = -127;
      analyser.maxDecibels = 0;
      analyser.smoothingTimeConstant = 0.4;
      audioSource.connect(analyser);
      const volumes = new Uint8Array(analyser.frequencyBinCount);
      this.volumeCallback = () => {
        analyser.getByteFrequencyData(volumes);
        let volumeSum = 0;
        // eslint-disable-next-line no-restricted-syntax
        for (const volume of volumes) volumeSum += volume;
        const averageVolume = volumeSum / volumes.length;
        this.volumeVisualizer.style.setProperty('--volume', `${averageVolume * 100 / 127}%`);
      };
    },
    throwCameraError() {
      this.$toast.error('We could not find your microphone, please check your microphone and try again', {
        toastClassName: ['toast-std', 'warning-toast'],
      });
    },
  },
};
</script>
